import { EMAIL_MAX_CHARS } from "../../email";

export const LEGAL_AGE = 21;

export const acpV3PropsMaxLength = {
	nhsAdditionalRequests: {
		request: 900,
	},
	healthConcerns: {
		description: 100,
	},
	personalExperiences: {
		label: 85,
		statement: 400,
	},
	treatmeanGoal: {
		description: 300,
	},
	carePreferences: {
		PAIN_MANAGEMENT: 100,
		COMPANIONSHIP_AND_EMOTIONAL_SUPPORT: 100,
		PERSONAL_HYGIENE: 100,
		MOBILITY_AND_EXERCISE: 100,
		CULTURAL_AND_SPIRITIAL_NEEDS: 100,
		PERSONAL_COMFORT_ITEMS: 100,
		CARE_OTHERS_DEC: 40,
		CARE_OTHERS_ITEMS: 100,
		CARE_LABEL: 80,
	},
	fears: {
		FEAR_STATEMENT_CARD: 150,
		FEAR_LABEL: 80,
	},
	goalsOfCare: {
		GOALS_OF_CARE_LABEL: 85,
		GOALS_OF_CARE_DESCRIPTION: 360,
		GOALS_OF_CARE_BANNER: 300,
	},
	nhs: {
		NHS_INFO: 80,
		NHS_CONTACT: 35,
		NHS_RELATION: 35,
	},
	personalDetails: {
		PERSONAL_INFO: 40,
	},
	personalHealth: {
		PERSONAL_HEALTH_LABEL: 85,
		PERSONAL_HEALTH_STATEMENT: 100,
	},
	sourceOfSupport: {
		SOURCES_OF_SUPPORT_LABEL: 80,
		SOURCES_OF_SUPPORT_DESCRIPTION: 150,
	},
	thingsYouEnjoyInLife: {
		ACTIVITY_LABEL: 40,
		ACTIVITY_DESCRIPTION: 500,
	},
};

export const acpV3PropsMaxLengthV2 = {
	personalDetails: {
		name: 128,
		nric: 70,
		citizenship: 100,
		passType: 100,
		dob: 20,
		gender: 20,
		maritalStatus: 20,
		race: 20,
		religion: 20,
		phone: 8,
		email: EMAIL_MAX_CHARS,

		block: 50,
		level: 50,
		unit: 50,
		street: 100,
		postalCode: 6,
	},

	healthConcerns: {
		description: 100,
	},

	personalExperience: {
		description: 400,
	},

	thingsYouEnjoyInLife: {
		otherSelection: 40,
		description: 500,
	},

	sourceOfSupport: {
		otherSource: 40,
		description: 150,
	},

	fears: {
		description: 150,
		otherFear: 40,
	},

	goalsOfCare: {
		description: 300,
		procedureToAvoid: 300,
	},

	carePreference: {
		otherCarePreference: 40,
		description: 100,
	},

	nhs: {
		name: 128,
		relationship: 15,
		otherRelationship: 20,
		mobile: 15,
		email: EMAIL_MAX_CHARS,

		nric: 70,
		dob: 20,
	},

	// Maximum number of NHS in the array
	appointedNhs: 2,

	nhsAdditionalRequests: {
		request: 900,
	},
};

// ACP Form Types
export enum AcpFormTypes {
	GENERAL = "General",
	PREFERRED_PLAN_OF_CARE = "Preferred Plan of Care",
	DISEASE_SPECIFIC = "Disease Specific",
}

export enum AcpFormStep {
	PERSONAL_DETAILS = "step1",
	HEALTH_CONCERN = "step2a",
	PERSONAL_EXPERIENCES = "step2b",
	THINGS_YOU_ENJOY = "step3a",
	SOURCES_OF_SUPPORT = "step3b",
	FEARS = "step4",
	GOALS_OF_CARE = "step5",
	CARE_PREFERENCES = "step6",
	NHS = "step7a",
	NHS_ADDITIONAL_REQUESTS = "step7b",
	REVIEW = "step8",
}

export enum HasHealthConcernValues {
	YES = "YES",
	NO = "NO",
}

export type ViewPatientInfoErrorCode = "E001" | "E002" | "E003" | "E004" | "E005" | "E006" | "E007" | null;

export enum ViewPatientInfoErrorEnum {
	E001 = "E001",
	E002 = "E002",
	E003 = "E003",
	E004 = "E004",
	E005 = "E005",
	E006 = "E006",
	E007 = "E007",
}
